// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1552":"quotation-topbar-v3","5571":"settings","6136":"RevvSign","6857":"document","9058":"quotation-topbar-v2"}[chunkId] + "." + {"1552":"3c5d8a47","5571":"17cd15f8","6136":"20f16e47","6857":"94d2fe12","9058":"3c5d8a47"}[chunkId] + ".chunk.css";
};